<template>
  <div class="mt-3">
    <h2 class="fw-bold">
      <span class="text-teal">Preenchimento de Metas</span>
    </h2>
  </div>
  <div class="card border-start border-start-width-3 border-start-teal">
    <form @submit.prevent="search">
      <div class="card-body">
        <div class="row g-3">
          <div class="col-md-4">
            <select
              class="form-select select2"
              v-model="v$.filters.codCCustoPai.$model"
              v-select2
            >
              <option value="" disabled>
                Selecione um Centro de Custo (Agrupador)
              </option>
              <option
                v-for="centroCustoPai in centrosCustosPais"
                :key="centroCustoPai.codCCustoPai"
                :value="centroCustoPai.codCCustoPai"
                :title="`${centroCustoPai.codCCustoPai} - ${centroCustoPai.nomeCCustoPai}`"
              >
                {{ centroCustoPai.codCCustoPai }} -
                {{ centroCustoPai.nomeCCustoPai }}
              </option>
            </select>
          </div>
          <div class="col-md-3">
            <select
              class="form-select select2"
              v-model="v$.filters.orcamentoId.$model"
              @change="alterarOrcamentoSelecionado"
              v-select2
            >
              <option value="" disabled>Selecione o Ano</option>
              <option
                v-for="orcamento in orcamentos"
                :key="orcamento.id"
                :value="orcamento.id"
                :title="orcamento.ano"
              >
                {{ orcamento.ano }}
              </option>
            </select>
          </div>
          <div class="col-md-3">
            <select
              class="form-select select2"
              v-model="v$.filters.periodoOrcamento.$model"
              v-select2
            >
              <option value="" disabled>Considerar o Valor</option>
              <option value="1" title="Proposto">Proposto</option>
              <option value="2" title="Reformulado">Reformulado</option>
            </select>
          </div>
          <div class="col-md-2">
            <button
              type="submit"
              class="btn btn-success w-100"
              title="Buscar"
              :disabled="v$.$invalid || searchData"
            >
              <span v-if="searchData">
                <i class="ph-spinner spinner" />
              </span>
              <span v-else>Buscar</span>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
  <MetasResult
    :searchData="searchData"
    :filters="filters"
    @searchData="searchData = false"
  />
</template>

<script>
import MetasResult from '@/components/metas/MetasResult.vue'
import { mapGetters } from 'vuex'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import select2 from 'select2'
import PeriodoAtivoEnum from '@/enum/periodoAtivoEnum'

export default {
  name: 'Metas',

  components: {
    MetasResult,
  },

  setup() {
    return { v$: useVuelidate() }
  },

  data() {
    return {
      centrosCustosPais: [],
      orcamentos: [],
      filters: {
        codCCustoPai: '',
        orcamentoId: '',
        periodoOrcamento: '',
      },
      searchData: false,
    }
  },

  computed: {
    ...mapGetters(['orcamentoSelecionado']),

    periodoOrcamentoProposta() {
      return (
        this.orcamentoSelecionado.periodoOrcamento === PeriodoAtivoEnum.PROPOSTA
      )
    },

    periodoOrcamentoReformulacao() {
      return (
        this.orcamentoSelecionado.periodoOrcamento ===
        PeriodoAtivoEnum.REFORMULACAO
      )
    },
  },

  methods: {
    async getInitialRegistros() {
      try {
        this.filters.codCCustoPai = this.$route.query.codCCustoPai

        await this.getCentrosCustosPais()
        await this.getOrcamentos()

        this.filters.orcamentoId = this.orcamentoSelecionado.id

        if (this.periodoOrcamentoProposta) {
          this.filters.periodoOrcamento = PeriodoAtivoEnum.PROPOSTA
        }
        if (this.periodoOrcamentoReformulacao) {
          this.filters.periodoOrcamento = PeriodoAtivoEnum.REFORMULACAO
        }

        this.search()
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async getCentrosCustosPais() {
      try {
        this.centrosCustosPais = await this.$store.dispatch(
          'getCentrosCustosPais',
        )
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async getOrcamentos() {
      try {
        this.orcamentos = await this.$store.dispatch('getOrcamentos')
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async search() {
      if (!this.v$.$invalid) {
        this.searchData = true
      }
    },

    alterarOrcamentoSelecionado(event) {
      const orcamentoSelecionado = this.orcamentos.find(
        (orcamento) => orcamento.id === event.target.value,
      )
      this.$store.dispatch('setOrcamentoSelecionado', orcamentoSelecionado)
    },
  },

  validations() {
    return {
      filters: {
        codCCustoPai: {
          required,
        },
        orcamentoId: {
          required,
        },
        periodoOrcamento: {
          required,
        },
      },
    }
  },

  mounted() {
    this.getInitialRegistros()

    window.$('.select2').select2({ width: '100%' })
  },
}
</script>
